import { render, staticRenderFns } from "./TipoCambioDetalle.vue?vue&type=template&id=254c1a06"
import script from "./TipoCambioDetalle.vue?vue&type=script&lang=js"
export * from "./TipoCambioDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports